import React from "react";
import { Form, Table } from "react-bootstrap";
import _ from "lodash";

import RenderAmount from "../../../Components/etc/RenderAmount";
import { getFullName } from "../../../Modules/utils/fullname";
import { monthDiff } from "../../../Modules/utils/etc";

class CustomerReceipt extends React.PureComponent {
  trnasactionColumns = [
    {
      value: "t",
      label: "Date",
      render: ({ item }) => new Date(item.t).toLocaleString(),
    },

    {
      value: "transactionType",
      label: "Type",
      render: ({ item }) => _.startCase(item.transactionType),
    },
    {
      value: "credit",
      label: "Credit",
      render: ({ item }) => (
        <RenderAmount value={item.side === "debit" && item.amount} />
      ),
    },
    {
      value: "debit",
      label: "Debit",
      render: ({ item }) => (
        <RenderAmount value={item.side === "credit" && item.amount} />
      ),
    },
    {
      value: "balance",
      label: "Balance",
      render: ({ item }) => (
        <RenderAmount
          value={
            this.props.data?.account?.accountType === "deposit"
              ? item.balance
                ? item.balance * -1
                : item.balance
              : item.balance
          }
        />
      ),
    },
  ];

  renderLoanAccountDetails() {
    const { data } = this.props;
    if (!data) return;

    const { account, previousTransaction } = data;

    return (
      <div style={{ flex: 1, margin: "0 1rem" }}>
        <Table bordered size="sm" className="vertical-table">
          <tbody>
            <tr>
              <th>Account ID</th>
              <td>{account.shortId}</td>
            </tr>
            <tr>
              <th>Name</th>
              <td style={{ fontWeight: "600" }}>
                {getFullName(account.customer)}
              </td>
            </tr>
            <tr>
              <th>Receipt Date</th>
              <td>{new Date().toLocaleString()}</td>
            </tr>
            <tr>
              <th>Collector</th>
              <td>{getFullName(account.collector)}</td>
            </tr>
            <tr>
              <th>Previous Balance</th>
              <td>
                <RenderAmount value={previousTransaction?.balance || 0} />
              </td>
            </tr>
            <tr>
              <th>Current Balance</th>
              <td>
                <RenderAmount value={account.balance} />
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }

  renderDepositAccountDetails() {
    const { data } = this.props;
    if (!data) return;

    const { account, previousTransaction } = data;

    return (
      <div style={{ flex: 1, margin: "0 1rem" }}>
        <Table bordered size="sm" className="vertical-table">
          <tbody>
            <tr>
              <th>Account ID</th>
              <td>{account.shortId}</td>
            </tr>
            <tr>
              <th>Receipt Date</th>
              <td>{new Date().toLocaleString()}</td>
            </tr>
            <tr>
              <th>Name</th>
              <td style={{ fontWeight: "500" }}>
                {getFullName(account.customer)}
              </td>
            </tr>
            <tr>
              <th>Recurring Amount</th>
              <td>{account.recurringAmount}</td>
            </tr>
            <tr>
              <th>Period</th>
              <td>
                {monthDiff(account.openingDate, account.endingDate)} months
              </td>
            </tr>
            <tr>
              <th>Opening Date</th>
              <td>{new Date(account.openingDate).toLocaleDateString()}</td>
            </tr>
            <tr>
              <th>Ending Date</th>
              <td>{new Date(account.endingDate).toLocaleDateString()}</td>
            </tr>
            {account.returningDate ? (
              <tr>
                <th>Returning Date</th>
                <td>{new Date(account.returningDate).toLocaleDateString()}</td>
              </tr>
            ) : null}
            {account.closed ? (
              <tr>
                <th>Account Closed At</th>
                <td>{new Date(account.closingDate).toLocaleDateString()}</td>
              </tr>
            ) : null}
            <tr>
              <th>Collector</th>
              <td>{getFullName(account.collector)}</td>
            </tr>
            <tr>
              <th>Previous Balance</th>
              <td>
                <RenderAmount
                  value={parseFloat(
                    (previousTransaction?.balance || 0) * -1
                  ).toFixed(2)}
                />
              </td>
            </tr>
            <tr>
              <th>Current Balance</th>
              <td>
                <RenderAmount
                  value={account.balance ? account.balance * -1 : 0}
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }

  renderDetails() {
    const { data } = this.props;
    if (!data) return;

    const { account } = data;
    if (account.accountType === "deposit")
      return this.renderDepositAccountDetails();
    else return this.renderLoanAccountDetails();
  }

  render() {
    const { data } = this.props;
    if (!data) return;

    const { transactions, range, account } = data;

    return (
      <div
        className="m-1 customerreceipt"
        style={{ minWidth: "20rem", fontSize: "0.95rem", paddingTop: "0.5rem" }}
      >
        <center>
          <h5 style={{}}>TN Dhing</h5>
        </center>
        <center>
          <span style={{ textDecoration: "underline" }}>
            {account?.accountType === "loan" ? "Recovery" : "Deposit"} Receipt
          </span>
        </center>

        <div style={{ textAlign: "right", marginRight: "1rem" }}>
          {new Date(range?.[0]).toLocaleDateString()} -{" "}
          {new Date(new Date(range?.[1]).getTime() - 1).toLocaleDateString()}
        </div>

        {this.renderDetails()}

        <div style={{ flex: 1, margin: "0 1rem" }}>
          <Form.Label>Transactions: </Form.Label>

          <div className="tablewrapper" style={{ fontSize: "0.85rem" }}>
            <Table className="itemstable" bordered>
              <tbody>
                <tr>
                  {this.trnasactionColumns?.map((x) => (
                    <th key={x.value}>{x.label}</th>
                  ))}
                </tr>
                {transactions?.map((item, index) => (
                  <tr key={item._id}>
                    {this.trnasactionColumns?.map((col) => {
                      return (
                        <td key={col.value}>
                          {col.render
                            ? col.render({ item, index })
                            : item[col.value]}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomerReceipt;
